module.exports = __webpack_public_path__ + "static/media/brand-refresh-UserCircle.7a15536e.svg";